const NotificationCategory = ["Mitteilung", "Suche", "Biete"];

const NotificationType = {
  category: "Mitteilung",
  text: "",
  contact: ""
};

export { NotificationCategory, NotificationType };
